(function () {
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');

  // تعديل: شلنا الـ 1.8 ثانية (كتيرة جداً) وخليناها 400 ملي ثانية عشان الموقع يفتح فوراً
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    viewTransitionRenderBlocker?.remove();
  } else {
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 400 - performance.now()); 
    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = event;

    // حماية: إذا الجهاز ضعيف، كنسل الحركة فوراً عشان ما يجمد
    if (shouldSkipViewTransition(viewTransition)) {
      viewTransition?.skipTransition();
      return;
    }

    // تعديل للأداء: البحث عن العناصر المكررة صار "أخف" عشان ما يهنّق التلفون
    try {
      const transitionType = document.querySelector('[data-view-transition-triggered]')?.getAttribute('data-view-transition-type');

      if (transitionType) {
        viewTransition.types.clear();
        viewTransition.types.add(transitionType);
        sessionStorage.setItem('custom-transition-type', transitionType);
      } else {
        viewTransition.types.clear();
        viewTransition.types.add('page-navigation');
        sessionStorage.removeItem('custom-transition-type');
      }
    } catch (e) {
      viewTransition.skipTransition(); // لو صار أي ضغط، كنسل الحركة وادخل الصفحة طبيعي
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = event;

    if (shouldSkipViewTransition(viewTransition)) {
        viewTransition?.skipTransition();
        return;
    }

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      try {
        viewTransition.types.clear();
        viewTransition.types.add(customTransitionType);
        await viewTransition.finished;
        viewTransition.types.clear();
        viewTransition.types.add('page-navigation');
      } catch (e) {}
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  function shouldSkipViewTransition(viewTransition) {
    // تعديل: كنسل الحركات على الموبايلات تماماً للسرعة القصوى
    return !(viewTransition instanceof ViewTransition) || isLowPowerDevice() || window.innerWidth < 768;
  }

  function isLowPowerDevice() {
    return Number(navigator.hardwareConcurrency) <= 4 || Number(navigator.deviceMemory) <= 4;
  }
})();
